

export default {
    leaveType : state => (leaveTypeId) => state.getAllLeaveTypes.find(a => a.leaveTypeId === leaveTypeId),

    approverName : state => () => state.approvers.filter((a) => a.priority === 1)[0],

    employeeFiledLeave: state => (employeeFiledLeaveId) => {
        return state.employeeFiledLeaves.find(u => u.employeeFiledLeaveId === employeeFiledLeaveId)
    },

    tenantsScheduleByDayName : state => (daysName) => state.tenantsSchedule.find((a) => a.daysName === daysName),

    tenantsScheduleByNumber: state => (scheduleNumberId) => state.tenantsSchedule.filter((a) => a.scheduleNumberId === scheduleNumberId),

    tenantName : state => (tenantId) => state.tenants.find((a) => a.tenantsId === tenantId),

    tenantSettings : state => (tenantId) => state.tenantsSettings.find(a => a.tenantsId === tenantId),


}